import { cssVar } from '@mfw/common';
import type { RadioProps } from '@mui/material/Radio';
import type { Theme } from '@mui/material/styles';

import { radioClasses } from '@mui/material/Radio';

import type { OnSurfaceMarkFamily } from '../../onSurface';

import { ON_SURFACE_MARK_FAMILIES, onSurfaceMark } from '../../onSurface';

// ----------------------------------------------------------------------

export function radio(theme: Theme) {
  return {
    // CHECKBOX, RADIO, SWITCH
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          ...theme.typography.body2,
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: RadioProps }) => {
          const { color } = ownerState;

          return {
            padding: theme.spacing(1),
            ...(color === 'default' && {
              [`&.${radioClasses.checked}`]: {
                color: cssVar.text.primary,
              },
            }),
            // The checked ring and its dot are the state, drawn on the page: a
            // MARK, so the step measured at 3:1 against the page and the cards
            // rather than MUI's `<color>.main` (1.7:1 on a light tenant). Before
            // the disabled block, which must win.
            ...(ON_SURFACE_MARK_FAMILIES.includes(
              color as OnSurfaceMarkFamily,
            ) && {
              [`&.${radioClasses.checked}`]: {
                color: onSurfaceMark[color as OnSurfaceMarkFamily],
              },
            }),
            [`&.${radioClasses.disabled}`]: {
              color: theme.palette.action.disabled,
            },
          };
        },
      },
    },
  };
}
